import * as React from "react"

function SvgSelectPlan(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      vectornator="http://vectornator.io"
      viewBox="0 0 208.794 173.944"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g layerName="Group 16">
        <path
          d="M18.106 37.094c-6.8 0-12.311-5.512-12.311-12.311 0-6.8 5.511-12.312 12.31-12.312h112.053c6.799 0 12.311 5.512 12.311 12.312s-5.512 12.311-12.311 12.311H18.106z"
          fill="#2196f3"
        />
        <path
          d="M18.106 14.077C12.193 14.077 7.4 18.87 7.4 24.783c0 5.912 4.793 10.705 10.706 10.705h112.052c5.912 0 10.705-4.793 10.705-10.705 0-5.913-4.793-10.706-10.705-10.706H18.106z"
          fill="#fff"
        />
        <path
          d="M51.74 14.077h.356v21.411h-.357V14.077zM96.168 14.077h.356v21.411h-.356V14.077z"
          fill="#2196f3"
        />
        <path d="M52.096 14.077h44.072v21.411H52.096V14.077z" fill="#00bfa6" />
        <path
          d="M74.152 18.255a6.548 6.548 0 100 13.095 6.548 6.548 0 000-13.095zm0 1.964a1.964 1.964 0 110 3.928 1.964 1.964 0 010-3.928zm0 9.457a4.77 4.77 0 01-3.929-2.097c.032-1.31 2.62-2.03 3.929-2.03 1.31 0 3.897.72 3.929 2.03a4.778 4.778 0 01-3.93 2.097z"
          fill="#fff"
        />
        <path
          d="M29.723 18.255a6.548 6.548 0 100 13.095 6.548 6.548 0 000-13.095zm0 1.964a1.964 1.964 0 110 3.929 1.964 1.964 0 010-3.929zm0 9.457a4.77 4.77 0 01-3.929-2.097c.031-1.31 2.62-2.03 3.929-2.03 1.31 0 3.897.72 3.928 2.03a4.778 4.778 0 01-3.928 2.097zM118.539 18.255a6.548 6.548 0 100 13.096 6.548 6.548 0 000-13.096zm0 1.964a1.964 1.964 0 110 3.928 1.964 1.964 0 010-3.928zm0 9.457a4.771 4.771 0 01-3.929-2.097c.032-1.31 2.619-2.03 3.929-2.03 1.31 0 3.897.72 3.929 2.03a4.779 4.779 0 01-3.929 2.097z"
          fill="#2196f3"
        />
        <path
          d="M68.15 46.067h12.004c.904 0 1.637.733 1.637 1.637v12.004c0 .904-.733 1.637-1.637 1.637H68.15a1.637 1.637 0 01-1.637-1.637V47.704c0-.904.733-1.637 1.637-1.637z"
          fill="#2196f3"
        />
        <path
          d="M132.641 144.999c0-2.712 16.421-4.911 36.678-4.911 20.256 0 36.678 2.199 36.678 4.911 0 2.712-16.422 4.911-36.678 4.911-20.257 0-36.678-2.199-36.678-4.911z"
          fillOpacity={0.186}
          fill="#2196f3"
        />
        <path
          d="M112.538 46.018h12.004c.904 0 1.637.733 1.637 1.637V59.66c0 .904-.733 1.637-1.637 1.637h-12.004a1.637 1.637 0 01-1.637-1.637V47.655c0-.904.733-1.637 1.637-1.637z"
          fill="#2196f3"
        />
        <path
          d="M113.084 48.141h11.13v11.13h-11.13v-11.13zM73.435 56.078l-1.93-2.482 1.122-.873.914 1.175 3.088-3.26 1.033.979-4.227 4.461z"
          fill="#fff"
        />
        <path
          d="M117.896 56.078l-1.93-2.482 1.122-.873.914 1.175 3.088-3.26 1.032.979-4.226 4.461zM23.722 46.018h12.004c.904 0 1.637.733 1.637 1.637V59.66c0 .904-.733 1.637-1.637 1.637H23.722a1.637 1.637 0 01-1.637-1.637V47.655c0-.904.733-1.637 1.637-1.637z"
          fill="#2196f3"
        />
        <path d="M24.267 48.141h11.13v11.13h-11.13v-11.13z" fill="#fff" />
        <path
          d="M29.08 56.078l-1.93-2.482 1.122-.873.914 1.175 3.087-3.26 1.033.979-4.226 4.461z"
          fill="#2196f3"
        />
        <path
          d="M194.044 141.116h-3.596l-1.71-13.869h5.307l-.001 13.869z"
          fill="#ffb8b8"
        />
        <path
          d="M187.878 140.089h6.935v4.365h-11.3a4.365 4.365 0 014.365-4.365z"
          fill="#2f2e41"
        />
        <path
          d="M157.309 141.116h-3.596l-1.71-13.869h5.307l-.001 13.869z"
          fill="#ffb8b8"
        />
        <path
          d="M151.144 140.089h6.935v4.365h-11.301a4.365 4.365 0 014.365-4.365h.001zM169.319 38.238v-1.573c0-5.602 4.541-10.143 10.143-10.143s10.144 4.54 10.144 10.143v1.572a7.312 7.312 0 01-7.312 7.312h-5.663a7.311 7.311 0 01-7.311-7.312h-.001z"
          fill="#2f2e41"
        />
        <path
          d="M171.737 38.367a7.726 7.726 0 1115.451 0 7.726 7.726 0 01-15.451 0zM137.443 64.916a2.948 2.948 0 014.491.527l6.622-1.252 1.743 3.838-9.377 1.637a2.965 2.965 0 01-3.479-4.75z"
          fill="#ffb8b8"
        />
        <path
          d="M173.44 50.956l.086.132-10.858 7.153-18.324 5.852c-.501.16-.818.653-.759 1.175l.4 3.444a1.102 1.102 0 001.324.949l17.246-3.697a6.227 6.227 0 002.319-1.02l12.198-8.68a3.137 3.137 0 00-3.547-5.175l-.085-.133z"
          fill="#ccc"
        />
        <path
          d="M190.512 137.181a1.42 1.42 0 01-1.301-.85l-16.484-40.732a.472.472 0 00-.884.05l-13.449 39.654a1.412 1.412 0 01-1.85.909l-4.509-1.691a1.413 1.413 0 01-.912-1.166c-2.029-17.673 15.664-62.285 15.843-62.734l.05-.124 16.128 3.568.033.036c6.435 7.02 11.724 51.294 12.719 60.098a1.409 1.409 0 01-.935 1.493l-3.981 1.408c-.15.053-.308.08-.468.08v.001z"
          fill="#2f2e41"
        />
        <path
          d="M176.616 75.502c-3.907 0-8.264-.78-9.605-3.995l-.03-.074.041-.068c1.059-1.737 2.458-4.7 1.706-5.255-1.481-1.096-2.2-2.897-2.136-5.355.138-5.337 3.774-10.074 9.047-11.79a40.19 40.19 0 014.486-1.155 7.636 7.636 0 016.332 1.564 7.714 7.714 0 012.861 5.935c.055 5.702-.822 13.645-5.32 19.098a1.4 1.4 0 01-.828.481 38.451 38.451 0 01-6.554.614z"
          fill="#ccc"
        />
        <path
          d="M175.163 75.287a3.005 3.005 0 013.673-2.096c.156.044.309.1.455.169l5.029-4.576 3.497 2.356-7.191 6.363a3.001 3.001 0 01-3.401 1.442 2.953 2.953 0 01-2.062-3.658z"
          fill="#ffb8b8"
        />
        <path
          d="M183.523 75.345a1.41 1.41 0 01-.895-.32l-1.983-1.62a1.414 1.414 0 01.034-2.22l8.317-6.378a.473.473 0 00.089-.659l-5.133-6.786a4.177 4.177 0 01.279-5.384 4.167 4.167 0 015.626-.45l.032.035 5.361 7.675a4.778 4.778 0 01-.114 7.607l-10.771 8.222c-.244.18-.539.277-.842.277v.001z"
          fill="#ccc"
        />
        <path
          d="M172.62 36.193V32.36l6.843-2.989 6.524 2.988v3.833c0 .348-.281.63-.629.63h-12.109a.629.629 0 01-.629-.63v.001zM181.027 26.116a4.29 4.29 0 118.58 0 4.29 4.29 0 01-8.58 0z"
          fill="#2f2e41"
        />
        <path
          d="M181.357 23.815a4.288 4.288 0 015.129-4.206 4.286 4.286 0 10-2.664 8.083 4.287 4.287 0 01-2.464-3.877h-.001z"
          fill="#2f2e41"
        />
      </g>
    </svg>
  )
}

export default SvgSelectPlan
